/* Cart-add bridge: whenever ANY script adds to cart via fetch or XHR,
   refresh + open the theme cart drawer. Fixes Dawn-style apps on FoxTheme. */
(function () {
  var DEBOUNCE_MS = 300, timer = null;

  function openDrawer() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      try {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        if (drawer.hasAttribute('open')) return; // theme already opened it
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      } catch (e) { /* never break the page from the bridge */ }
    }, DEBOUNCE_MS);
  }

  function isCartAdd(url) {
    return typeof url === 'string' && /\/cart\/add(\.js)?([?#]|$)/.test(url);
  }

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (isCartAdd(url)) p.then(function (res) { if (res && res.ok) openDrawer(); }).catch(function () {});
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartAdd(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) openDrawer();
      });
    }
    return _open.apply(this, arguments);
  };
})();